import React from 'react';

const Resume = () => {
      return (
            <section>
                  <div className="justify-content-center d-flex mt-5">
                        <a href="https://drive.google.com/uc?id=1kdHSWUWhL5l2wu6UFje_Xb_JaEMuXaYW&export=download" target="_blank" rel='noreferrer'>
                              <button className='btn hvr-sweep-to-right'><i class="fas fa-cloud-download-alt"></i> Download Resume <small>.PDF</small></button>
                        </a>
                  </div>
            </section>
      );
};

export default Resume;